import { render, staticRenderFns } from "./line4Right.vue?vue&type=template&id=445c0988&scoped=true&"
import script from "./line4Right.vue?vue&type=script&lang=js&"
export * from "./line4Right.vue?vue&type=script&lang=js&"
import style0 from "./line4Right.vue?vue&type=style&index=0&id=445c0988&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c0988",
  null
  
)

export default component.exports